import React from 'react';

export default function SocialLink(props) {
    const { tooltipText, link, icon } = props;
    return (
        <a className="tooltip tooltip--bottom" data-tooltip={tooltipText} href={link} target="_blank" rel="noreferrer">
            {icon}
        </a>
    );
}